import { render, staticRenderFns } from "./CustomFormFieldsEdit.vue?vue&type=template&id=60eca15f&scoped=true"
import script from "./CustomFormFieldsEdit.vue?vue&type=script&lang=js"
export * from "./CustomFormFieldsEdit.vue?vue&type=script&lang=js"
import style0 from "./CustomFormFieldsEdit.vue?vue&type=style&index=0&id=60eca15f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60eca15f",
  null
  
)

export default component.exports